$(document).ready(function () {
  //For Triggering the animation of Sacred Section 5
  $('.sacred-sec5').each(function () {
    const $element = $(this);
    const observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          $element.addClass('visible');
          observer.unobserve(entry.target); // optional: stop observing once visible
        }
      });
    }, { threshold: 0.5 });

    observer.observe(this);
  });


   // Removing current card on collection category
  const currentUrl = window.location.href;
  const currentPath = window.location.pathname;

    $('.collection-list .collection-list__item').each(function() {
      const link = $(this).find('.card__heading a').attr('href');
  
      // Match either full URL or relative path
      if (link === currentUrl || link === currentPath) {
        $(this).remove();
      }
    });
     //Forcess all collection to go to collection page
     $('.cstm-product .breadcrumb-main-template a').each(function() {
      const link = $(this).attr('href');
    
      if (link === '/collections/all') {
        $(this).attr('href', '/collections/');
      }
    });
});



